import * as React from "react";

import { cn } from "@/lib/utils";

// Figma 문의 내용 박스 (ver.6 546:1426): border #E6E6E3 r12, padding 16, 14/17
export interface NvTextareaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: string;
}

const NvTextarea = React.forwardRef<HTMLTextAreaElement, NvTextareaProps>(({ className, error, ...props }, ref) => (
  <div className="flex flex-col gap-[6px]">
    <textarea
      ref={ref}
      aria-invalid={error ? true : undefined}
      className={cn(
        "min-h-[150px] w-full resize-y rounded-nv-card border bg-nv-surface p-4 text-[14px] leading-[17px] text-nv-text-strong placeholder:text-nv-text-secondary focus-visible:border-nv-brand focus-visible:outline-none",
        error ? "border-nv-danger" : "border-nv-border",
        className,
      )}
      {...props}
    />
    {error && <p className="text-nv-caption text-nv-danger">{error}</p>}
  </div>
));
NvTextarea.displayName = "NvTextarea";

export { NvTextarea };
